var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 90,
    viewBox: "0 0 100 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1523",
    filter: "url(#filter0_d_1909_7226)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 4.42676,
    y: 5,
    width: 75.0199,
    height: 64,
    rx: 4.43,
    fill: "white",
    stroke: "#D2DDE9",
    strokeOpacity: 0.5,
    strokeWidth: 0.464259
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 895",
    x: 7.99878,
    y: 25.4766,
    width: 17.4135,
    height: 2.2325,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 906",
    x: 7.99878,
    y: 29.9453,
    width: 33.041,
    height: 2.2325,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 910",
    x: 7.99878,
    y: 34.4062,
    width: 33.041,
    height: 2.2325,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 911",
    x: 7.99878,
    y: 38.8711,
    width: 33.041,
    height: 2.2325,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 903",
    x: 7.99878,
    y: 21.4609,
    width: 17.4135,
    height: 1.786,
    rx: 0.893,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 905",
    opacity: 0.6,
    x: 7.99878,
    y: 16.9922,
    width: 17.4135,
    height: 2.2325,
    rx: 0.928519,
    fill: "#EDF1F6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 900",
    opacity: 0.5,
    x: 21.7131,
    y: 55.5391,
    width: 14.5611,
    height: 1.786,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Placeholder",
    opacity: 0.3,
    d: "M18.55 50.9219H8.03571C7.98187 50.9219 7.93823 51.0777 7.93823 51.2699V60.4125C7.93823 60.6047 7.98187 60.7605 8.03571 60.7605H18.55C18.6039 60.7605 18.6475 60.6047 18.6475 60.4125V51.2699C18.6475 51.0777 18.6039 50.9219 18.55 50.9219Z",
    fill: "#5378B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 2",
    d: "M15.0172 54.371C15.2705 54.371 15.4759 54.1638 15.4759 53.9082C15.4759 53.6525 15.2705 53.4453 15.0172 53.4453C14.7639 53.4453 14.5586 53.6525 14.5586 53.9082C14.5586 54.1638 14.7639 54.371 15.0172 54.371Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 836",
    d: "M15.0444 57.1758C15.0444 57.1758 14.9663 57.1758 14.871 57.1758H10.928C10.8322 57.1758 10.7957 57.1096 10.8465 57.028L12.7719 53.9348C12.8227 53.8532 12.9073 53.8527 12.9598 53.9323L14.6465 56.512",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2",
    d: "M13.6766 57.1769C13.6766 57.1769 13.7175 57.111 13.7687 57.0286L14.8798 55.2399C14.9307 55.158 15.016 55.1557 15.0706 55.2351L16.2693 56.9769C16.3238 57.0561 16.2908 57.1228 16.194 57.1258L15.15 57.1581",
    fill: "#F2F6FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Placeholder_2",
    opacity: 0.3,
    d: "M58.6941 51.1992H48.1798C48.1259 51.1992 48.0823 51.355 48.0823 51.5472V60.6898C48.0823 60.882 48.1259 61.0378 48.1798 61.0378H58.6941C58.7479 61.0378 58.7916 60.882 58.7916 60.6898V51.5472C58.7916 51.355 58.7479 51.1992 58.6941 51.1992Z",
    fill: "#5378B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 2_2",
    d: "M54.7142 54.6483C54.9675 54.6483 55.1729 54.4411 55.1729 54.1855C55.1729 53.9299 54.9675 53.7227 54.7142 53.7227C54.461 53.7227 54.2556 53.9299 54.2556 54.1855C54.2556 54.4411 54.461 54.6483 54.7142 54.6483Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 836_2",
    d: "M54.7415 57.4531C54.7415 57.4531 54.6633 57.4531 54.568 57.4531H50.625C50.5292 57.4531 50.4927 57.387 50.5435 57.3053L52.4689 54.2121C52.5198 54.1305 52.6043 54.1301 52.6568 54.2096L54.3435 56.7893",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_2",
    d: "M53.3736 57.4542C53.3736 57.4542 53.4145 57.3883 53.4657 57.3059L54.5768 55.5172C54.6277 55.4353 54.713 55.433 54.7677 55.5124L55.9663 57.2542C56.0209 57.3335 55.9879 57.4001 55.891 57.4031L54.8471 57.4354",
    fill: "#F2F6FB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1538_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Placeholder_3",
    opacity: 0.3,
    d: "M74.5451 16.8672H48.7453C48.6132 16.8672 48.5061 17.2495 48.5061 17.7211V40.155C48.5061 40.6266 48.6132 41.0089 48.7453 41.0089H74.5451C74.6772 41.0089 74.7843 40.6266 74.7843 40.155V17.7211C74.7843 17.2495 74.6772 16.8672 74.5451 16.8672Z",
    fill: "#5378B5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 2_3",
    d: "M64.7787 25.3339C65.4002 25.3339 65.9041 24.8254 65.9041 24.1982C65.9041 23.571 65.4002 23.0625 64.7787 23.0625C64.1572 23.0625 63.6533 23.571 63.6533 24.1982C63.6533 24.8254 64.1572 25.3339 64.7787 25.3339Z",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 836_3",
    d: "M64.8457 32.2109C64.8457 32.2109 64.654 32.2109 64.42 32.2109H54.7449C54.5098 32.2109 54.4203 32.0486 54.545 31.8483L59.2695 24.2583C59.3941 24.058 59.6017 24.0569 59.7305 24.2522L63.8693 30.5821",
    fill: "#F2F6FB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2_3",
    d: "M61.4896 32.2153C61.4896 32.2153 61.59 32.0537 61.7156 31.8514L64.4421 27.4625C64.5669 27.2615 64.7763 27.2558 64.9104 27.4506L67.8517 31.7247C67.9854 31.9191 67.9045 32.0826 67.6669 32.0899L65.1052 32.1693",
    fill: "#F2F6FB"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 907",
    opacity: 0.5,
    x: 60.282,
    y: 55.4219,
    width: 14.5611,
    height: 1.786,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 899",
    opacity: 0.5,
    x: 21.7131,
    y: 52.3906,
    width: 14.5611,
    height: 1.786,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 908",
    opacity: 0.5,
    x: 60.282,
    y: 52.2734,
    width: 14.5611,
    height: 1.786,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 901",
    opacity: 0.5,
    x: 21.7131,
    y: 58.6875,
    width: 14.5611,
    height: 1.786,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 909",
    opacity: 0.5,
    x: 60.282,
    y: 58.5703,
    width: 14.5611,
    height: 1.786,
    rx: 0.464259,
    fill: "#D2DDE9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 901_2",
    d: "M4.42676 9.43C4.42676 6.98338 6.41014 5 8.85676 5H75.143C77.5897 5 79.573 6.98338 79.573 9.43V12.0838H4.42676V9.43Z",
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 48",
    cx: 10.21,
    cy: 8.42194,
    rx: 1.06228,
    ry: 1.06257,
    fill: "#FF889D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 49",
    cx: 13.9871,
    cy: 8.42194,
    rx: 1.06228,
    ry: 1.06257,
    fill: "#FBE597"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 50",
    cx: 17.5283,
    cy: 8.42194,
    rx: 1.06228,
    ry: 1.06257,
    fill: "#6EEFBB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_7226",
    x: 0.19458,
    y: 0.769531,
    width: 99.4841,
    height: 88.4609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.497656 0 0 0 0 0.619531 0 0 0 0 0.8125 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_7226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_7226",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcon);
export default __webpack_public_path__ + "static/media/projectIcon.d9996818faf2e3283cab5fa7acc0c9c1.svg";
export { ForwardRef as ReactComponent };